import React, { Component } from 'react';
import gql from 'graphql-tag';
import graphql from "react-apollo/graphql";
import { compose } from 'react-apollo';

const contentQuery = gql`
query contentQuery($id: Int!){
    content(id: $id){
        id, title, text, mark
    }
}
`;


const setRating = gql`
mutation setRating($contentId: Int!, $mark: Int!){
  setRating(contentId: $contentId, mark: $mark) {
    ok
    rating {
      mark
    }
  }
}
`;

class Content extends Component {
    handleKeyDown(e){
        console.log();
        e.preventDefault();
        if (e.keyCode === 37 || e.keyCode === 40 || e.keyCode === 27) { // left, down or escape
            this.pushNext(-1)
        } else if (e.keyCode === 38 || e.keyCode === 39 || e.keyCode === 13 || e.keyCode === 32) { // right, up, space, enter
            this.pushNext(1)
        }
    }
    pushNext(inc){
        const new_index = parseInt(this.props.match.params.contentId, 10)  + inc;
        if (new_index === 0){
            return
        }
        this.props.history.push('/view/' + new_index)
    }
    componentDidMount(){
        console.log('mount');
        document.addEventListener("keydown", (e)=>this.handleKeyDown(e), false);
    }
    componentWillUnmount(){
        console.log('unmount');
        document.removeEventListener("keydown", false);
    }
    onStarChange(e){
        this.props.mutate({
            variables: {
                mark: e.target.value,
                contentId: this.props.match.params.contentId
            },
            update: (proxy, {data: {setRating}}) => {
                // Read the data from our cache for this query.
                const mark = setRating.rating.mark;
                const data = proxy.readQuery({ query: contentQuery, variables: {id: this.props.match.params.contentId}});
                // console.log(data);
                data.content.mark = mark;

                // Write our data back to the cache.
                // console.log(data);
                proxy.writeQuery({ query: contentQuery, variables: {id: this.props.match.params.contentId}, data });
            },
        })
            // .then(({ data }) => {
            //     console.log('got data', data);
            // }).catch((error) => {
            // console.log('there was an error sending the query', error);
        // }
        // )
    }
    render(){
        const {loading, error, content} = this.props.data;
        if (loading) {
            return  (
                <div className="progress">
                    <div className="indeterminate"/>
                </div>);
        }
        if (error) {
            return <p>{error.message}</p>;
        }
        return (
            <div>
                <a className="btn-floating pulse" id="arrow_back" onClick={()=>this.pushNext(-1)}>
                    <i className="material-icons">arrow_back</i>
                </a>
                <p className="flow-text"
                   style={{textAlign: 'left'}}
                   dangerouslySetInnerHTML={{ __html: content.text.replace(/(?:\r\n|\r|\n)/g, '<br />')}}>

                </p>
                {/*<p className="flow-text">Оценка: {content.mark}</p>*/}
                <a className="btn-floating pulse" id="arrow_forward" onClick={()=>this.pushNext(1)}><i className="material-icons">arrow_forward</i></a>
                {this.props.isLogged && <div className="rate">
                    <input type="radio" id="star5" name="rate" value="5" checked={content.mark === 5}
                           onChange={e => this.onStarChange(e)}/>
                    <label htmlFor="star5" title="text">5 stars</label>
                    <input type="radio" id="star4" name="rate" value="4" checked={content.mark === 4}
                           onChange={e => this.onStarChange(e)}/>
                    <label htmlFor="star4" title="text">4 stars</label>
                    <input type="radio" id="star3" name="rate" value="3" checked={content.mark === 3}
                           onChange={e => this.onStarChange(e)}/>
                    <label htmlFor="star3" title="text">3 stars</label>
                    <input type="radio" id="star2" name="rate" value="2" checked={content.mark === 2}
                           onChange={e => this.onStarChange(e)}/>
                    <label htmlFor="star2" title="text">2 stars</label>
                    <input type="radio" id="star1" name="rate" value="1" checked={content.mark === 1}
                           onChange={e => this.onStarChange(e)}/>
                    <label htmlFor="star1" title="text">1 star</label>
                </div>
                }
            </div>
        )
    }
}


const ContentWithData = compose(
    graphql(contentQuery,{options: ({ match }) => ({variables: {id: match.params.contentId}})}),
    graphql(setRating),
)(Content);


export default ContentWithData;


// WEBPACK FOOTER //
// ./src/components/Content.js